import * as React from 'react';
import { Theme } from '@mui/material/styles';

import { MakeStylesHook, StyleRules, makeStyles } from '@egr/xbox/utils/tss-react';

interface FullscreenContainerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    visible: boolean;
    viewerID: string;

    moveUp?: boolean;
}

type FullscreenContainerClasses = 'root' | 'scene' | 'moveUp' | 'visible';

function getFullscreenContainerStyles(theme: Theme, params: unknown, classes: Record<FullscreenContainerClasses, string>): StyleRules<{}, FullscreenContainerClasses> {
    return {
        root: {
            display: 'flex',
            height: '100%',
            left: 0,
            position: 'absolute',
            top: 0,
            transform: 'translateY(0)',
            transitionDuration: '330ms',
            transitionProperty: 'transform',
            opacity: 0,
            width: '100%',
            zIndex: -1,
            userSelect: 'none',
            [`&.${classes.moveUp}`]: {
                transform: 'translateY(-25%)'
            },
            [`&.${classes.visible}`]: {
                opacity: 1,
            }
        },
        scene: {
            flexGrow: 1,
            display: 'flex',
            position: 'relative',
            overflow: 'hidden',
            flexShrink: 0,
            flexBasis: '100%',
            maxWidth: '100%',
            '& *, & *::before, & *::after': {
                boxSizing: 'initial'
            }
        },
        visible: { /* */ },
        moveUp: { /* */ },
    };
}

const useFullscreenContainerStyles: MakeStylesHook<FullscreenContainerClasses> = makeStyles<void, FullscreenContainerClasses>({ name: 'FullscreenContainer' })(getFullscreenContainerStyles);

export const FullscreenContainer: React.FC<FullscreenContainerProps> = (props) => {
    const { classes, cx } = useFullscreenContainerStyles();

    const { moveUp, visible, children, viewerID, className, ...divProps } = props;

    return (
        <div
            className={cx(
                classes.root,
                moveUp ? classes.moveUp : undefined,
                visible ? classes.visible : undefined,
            )}
            {...divProps}
        >
            <div className={classes.scene} id={viewerID}>
                {children}
            </div>
        </div>
    );
};